<div mat-dialog-title>
  <h2>Block Types</h2>
  <button mat-icon-button title="Close Dialog" data-testid="block-type-picker-close-button" class="mat-dialog-title__close" (click)="onClose()">
    <fa-icon [icon]="faClose"></fa-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <div class="type-picker-layout">
    <div class="left-side-column">
      <div class="side-content">
        <mat-action-list>
          @if (showParentBlock) {
            @for (type of parentBlockTypes; track type) {
              <button
                mat-list-item
                [attr.data-testid]="'block-type-' + type + '-button'"
                class="block-type__button"
                [class.active]="selectedType$() === type"
                (click)="selectedType$.set(type)"
              >
                <fa-icon [icon]="blockTypeConfig[type].icon"></fa-icon>
                <div class="item-text">
                  <span class="text text__sm fw__500">{{ blockTypeConfig[type].text }}</span>
                </div>
              </button>
            }
            <mat-divider />
          }
          @for (type of blockTypeListOrder; track type) {
            <button
              mat-list-item
              [attr.data-testid]="'block-type-' + type + '-button'"
              class="block-type__button"
              [class.active]="blockTypeConfig[type].type === selectedType$()"
              (click)="selectedType$.set(blockTypeConfig[type].type)"
            >
              <fa-icon [icon]="blockTypeConfig[type].icon"></fa-icon>
              <div class="item-text">
                <span class="text text__sm fw__500">{{ blockTypeConfig[type].text }}</span>
              </div>
            </button>
          }
        </mat-action-list>
      </div>
    </div>
    <div class="main-column">
      <div class="main-column-content">
        @switch (selectedType$()) {
          @case (blockType.MultiBlock) {
            <span class="text__md fw__600">Create and Group Multiple Blocks of Questions Together</span>
            <p class="text__sm fw__400">
              Start a <strong>new top-level section</strong> where you can create and organise multiple grouped question sets. Use this if you plan to build a
              larger section made up of smaller question groups.
            </p>
            <ul>
              <li>
                <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                <span class="text__sm fw__400">You can apply conditional logic to the entire section.</span>
              </li>
              <li>
                <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                <span class="text__sm fw__400">You can't move existing blocks into this section.</span>
              </li>
              <li>
                <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                <span class="text__sm fw__400">Start here first if you intend to organise multiple groups together.</span>
              </li>
            </ul>
          }
          @case (blockType.LoopParent) {
            <span class="text__md fw__600">Loop parent</span>
            <p>
              <span
                >Create child loops that run one complete iteration per round, skipping exhausted children. This parent has no source or allocation of its
                own.</span
              >
            </p>
          }
          @case (blockType.Loop) {
            <span class="text__md fw__600">Loop Questions</span>
            <p class="text__sm fw__400">
              Ask the <strong>same question(s) multiple times</strong> based on participant selections. Use a multi-choice question as the source (e.g., “Which
              products do you use?”), and follow-up questions will repeat for each selected item.
            </p>
          }
          @case (blockType.Group) {
            <span class="text__md fw__600">Create and Group a Single Set of Questions</span>
            <p class="text__sm fw__400">
              Group several related questions together and apply <strong>conditional logic</strong> to the whole set. Use this when you want to group a single
              set of questions together.
            </p>
          }
        }
      </div>
      <div class="main-column-actions">
        <button data-testid="block-type-picker-add-button" mat-flat-button [color]="'primary'" [mat-dialog-close]="selectedType$()" cdkFocusInitial>
          Add Block
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
